module.exports = {
	"ha": "bc",
	"id": 6.1,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for BC, 2018 Q3–2020 Q2 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020"
				],
				"tickPositions": [
					0,
					2,
					6
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					20.74688796680498,
					20.5607476635514,
					22.705314009661837,
					21.978021978021978,
					22.65193370165746,
					23.93617021276596,
					30.555555555555557,
					{
						"y": 31.521739130434785,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					9.54356846473029,
					9.345794392523365,
					9.66183574879227,
					10.43956043956044,
					9.94475138121547,
					10.638297872340425,
					13.333333333333334,
					{
						"y": 14.130434782608695,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					6.224066390041494,
					8.411214953271028,
					8.695652173913043,
					11.538461538461538,
					12.70718232044199,
					11.702127659574469,
					10,
					{
						"y": 9.782608695652174,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					23.236514522821576,
					22.897196261682243,
					18.84057971014493,
					20.87912087912088,
					20.994475138121548,
					18.617021276595743,
					21.11111111111111,
					{
						"y": 20.108695652173914,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					15.767634854771783,
					19.626168224299064,
					19.806763285024154,
					21.978021978021978,
					19.337016574585636,
					17.5531914893617,
					17.77777777777778,
					{
						"y": 16.304347826086957,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					25.72614107883817,
					26.168224299065418,
					26.08695652173913,
					24.725274725274726,
					25.41436464088398,
					25.53191489361702,
					28.888888888888886,
					{
						"y": 29.347826086956523,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					241,
					214,
					207,
					182,
					181,
					188,
					180,
					{
						"y": 184,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_6_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_6_1.json
// module id = 173
// module chunks = 0